<template>
  <div class="contenedorFecha">
    <v-menu
      v-model="menu"
      v-bind:close-on-content-click="false"
      offset-y
      full-width
      data-app="true"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :disabled="deshabilitado"
          :rules="obligatorio ? reglasObligatorio : []"
          placeholder="aaaa/mm/dd"
          class="autocomplete"
          dense
          rounded
          slot="activator"
          prepend-icon="event"
          v-model="valorString"
          v-bind:value="valorNumber"
          v-bind:readonly="readonly"
          v-bind:clearable="options.clearable"
          v-bind:label="label"
          v-on="on"
          color="#3DC4B9"
        ></v-text-field>
      </template>
      <v-date-picker
        :disabled="deshabilitado"
        color="#3F9AAE"
        landscape
        v-model="valorPicker"
        @change="
          seleccionarPicker();
          menu = false;
        "
        v-bind:locale="'es'"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      valorString: null,
      valorNumber: null,
      formatosPermitidos: [
        "YYYY-MM-DD",
        "DD-MM-YYYY",
        "DD/MM/YYYY",
        "YYYY/MM/DD",
      ],
      valorPicker: "",
      menu: false,
      readonly: false,
    };
  },
  mounted() {
    if (typeof this.value === "string" && !/^\d+$/.test(this.value)) {
      if (moment(this.value, this.formatosPermitidos, true).isValid()) {
        try {
          this.valorPicker = moment(this.value, this.formatosPermitidos, true)
            .tz("America/Bogota")
            .format("YYYY-MM-DD");
        } catch (err) {
          console.log(err);
        } finally {
          const [year, month, day] = this.valorPicker.split("-");
          this.valorString = `${day}/${month}/${year}`;
        }
      }
    } else if (typeof this.value === "string" && /^\d+$/.test(this.value)) {
      try {
        this.valorPicker = moment(Number(this.value))
          .tz("America/Bogota")
          .format("YYYY-MM-DD");
      } catch (err) {
        console.log(err);
      } finally {
        const [year, month, day] = this.valorPicker.split("-");
        this.valorString = `${day}/${month}/${year}`;
      }
    } else if (typeof this.value === "number") {
      try {
        this.valorPicker = moment(this.value)
          .tz("America/Bogota")
          .format("YYYY-MM-DD");
      } catch (err) {
        console.log(err);
      } finally {
        const [year, month, day] = this.valorPicker.split("-");
        this.valorString = `${day}/${month}/${year}`;
      }
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    reglasObligatorio: {
      type: Array,
      default: () => [],
    },
    obligatorio: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      default: "Label",
    },
    options: {
      type: Object,
      default: function () {
        return { locale: "es", format: "YYYY/MM/DD", clearable: false };
      },
    },
    deshabilitado: {
      type: Boolean,
      default: false,
    },
    banderaHasta: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    obtenerTimeStamp(strFecha) {
      try {
        if (moment(strFecha, this.formatosPermitidos, true).isValid()) {
          const a = Number(
            moment(strFecha, this.formatosPermitidos, true)
              .tz("America/Bogota")
              .format("x")
          );
          console.log("valorPicker", this.valorPicker);
          return a;
        } else {
          return null;
        }
      } catch (err) {
        console.log(err);
      }
    },
    seleccionarPicker() {
      if (!this.valorPicker) return;
      const [year, month, day] = this.valorPicker.split("-");
      this.valorString = `${day}/${month}/${year}`;
    },
  },
  watch: {
    valorString(newValue, oldValue) {
      this.valorNumber = this.obtenerTimeStamp(newValue);
      if (this.valorNumber !== null) {
        try {
          if (moment(newValue, this.formatosPermitidos, true).isValid()) {
            if (this.valorPicker !== newValue) {
              this.valorPicker = moment(newValue, this.formatosPermitidos, true)
                .tz("America/Bogota")
                .format("YYYY-MM-DD");
            }
          }
          this.$emit("input", this.valorNumber);
        } catch (err) {
          console.log(err);
        }
      } else {
        this.valorPicker = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/main.scss";
.v-menu__content.theme--light.menuable__content__active {
  min-width: min-content !important;
}
.tamano {
  // @extend %texto-alternativo;
  font-size: 16px;
  color: #00000099;
}
.color:active {
  min-width: 120px;
}
@media only screen and (max-width: 1120px) {
  .tamano {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DatePicker/Datepicker.vue